import IconButton from 'components/IconButton';
import { useAtom, WritableAtom } from 'jotai';

interface AppliedHostInfoProps {
  appliedHostIdsAtom: WritableAtom<number[], any[], void>;
}
const AppliedHostInfo = ({ appliedHostIdsAtom }: AppliedHostInfoProps) => {
  const [appliedHostIds, setAppliedHostIds] = useAtom(appliedHostIdsAtom);

  return appliedHostIds.length > 0 ? (
    <>
      <i className="fa fa-info-circle me-1 text-warning px-2"></i>
      Showing dashboard for selected <strong>
        {appliedHostIds.length}
      </strong>{' '}
      hosts only.&nbsp;
      <IconButton
        id="resetButton"
        iconClass="fa fa-undo fa-lg"
        tooltip="Reset Dashboard Charts"
        disabled={appliedHostIds.length === 0}
        onClick={() => setAppliedHostIds([])}
      />
    </>
  ) : (
    <></>
  );
};

export default AppliedHostInfo;
